import { useEffect, useState } from "react";
import { Wifi, WifiOff, RefreshCw } from "lucide-react";

// Explicit sync indicator for restaurant terminals (KDS / POS / Manager).
// 🟢 Synchronisé · 🟠 Synchronisation… (online but socket down) · 🔴 Hors ligne
export default function SyncStatus({ connected, queued = 0, className = "" }) {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    return () => { window.removeEventListener("online", up); window.removeEventListener("offline", down); };
  }, []);

  let state = "ok";
  if (!online) state = "off";
  else if (!connected) state = "wait";

  const cfg = {
    ok: { dot: "#34D399", label: "Synchronisé", Icon: Wifi, color: "text-emerald-500" },
    wait: { dot: "#F59E0B", label: "Reconnexion…", Icon: RefreshCw, color: "text-amber-500" },
    off: { dot: "#F87171", label: "Hors ligne", Icon: WifiOff, color: "text-red-500" },
  }[state];

  return (
    <span data-testid="sync-status" data-sync-state={state} data-queued={queued}
      className={`inline-flex items-center gap-1.5 ${className}`}>
      <span className={`w-2 h-2 rounded-full ${state === "wait" ? "animate-pulse" : ""}`} style={{ backgroundColor: cfg.dot }} />
      <cfg.Icon className={`w-3 h-3 ${cfg.color} ${state === "wait" ? "animate-spin" : ""}`} />
      <span className="whitespace-nowrap">{cfg.label}</span>
      {queued > 0 && (
        <span data-testid="sync-queued-badge" className="ml-1 rounded-full bg-amber-500/15 border border-amber-500/40 text-amber-400 text-[10px] font-bold px-1.5 py-0.5 whitespace-nowrap">
          {queued} en attente
        </span>
      )}
    </span>
  );
}
